module.exports = __webpack_public_path__ + "static/Homepage-Hero1-8f1f0276fff1c741292c5ab1b67b63c8.png";